<div [innerHTML]="'consumerDefence.first-paragraph' | translate"> </div>

<div [innerHTML]="'consumerDefence.second-paragraph' | translate" class="mt-3"> </div>

<div [innerHTML]="'consumerDefence.third-paragraph' | translate" class="mt-3"> </div>